__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "help-article-ui";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@bsd/auth-pkce-ui", "0.0.14", function() { return Promise.all([__webpack_require__.e(980), __webpack_require__.e(848)]).then(function() { return function() { return __webpack_require__(5980); }; }); });
			register("@bsd/service-agent-service-help-article-ui-api", "0.0.85", function() { return __webpack_require__.e(863).then(function() { return function() { return __webpack_require__(8863); }; }); });
			register("@bsd/ui-auth", "2.4.3", function() { return Promise.all([__webpack_require__.e(329), __webpack_require__.e(143)]).then(function() { return function() { return __webpack_require__(6329); }; }); });
			register("@bsd/ui-utils", "2.2.1", function() { return Promise.all([__webpack_require__.e(354), __webpack_require__.e(342)]).then(function() { return function() { return __webpack_require__(9354); }; }); });
			register("bxt-design-framework", "1.0.66", function() { return Promise.all([__webpack_require__.e(584), __webpack_require__.e(91)]).then(function() { return function() { return __webpack_require__(9584); }; }); });
			register("classnames", "2.3.1", function() { return __webpack_require__.e(485).then(function() { return function() { return __webpack_require__(2485); }; }); });
			register("date-fns", "2.28.0", function() { return __webpack_require__.e(992).then(function() { return function() { return __webpack_require__(1992); }; }); });
			register("fontfaceobserver", "2.3.0", function() { return __webpack_require__.e(904).then(function() { return function() { return __webpack_require__(8904); }; }); });
			register("js-cookie", "3.0.1", function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(8987); }; }); });
			register("prop-types", "15.8.1", function() { return __webpack_require__.e(556).then(function() { return function() { return __webpack_require__(5556); }; }); });
			register("react-dom", "18.3.1", function() { return Promise.all([__webpack_require__.e(961), __webpack_require__.e(283)]).then(function() { return function() { return __webpack_require__(961); }; }); });
			register("react-favicon", "2.0.7", function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(7974); }; }); });
			register("react-router-dom", "6.30.2", function() { return Promise.all([__webpack_require__.e(648), __webpack_require__.e(23)]).then(function() { return function() { return __webpack_require__(2648); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(159).then(function() { return function() { return __webpack_require__(6540); }; }); });
			register("uuid", "9.0.0", function() { return __webpack_require__.e(308).then(function() { return function() { return __webpack_require__(9308); }; }); });
			initExternal(9392);
			initExternal(1427);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};